var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAirportTransferIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06763 29.5217C6.44286 29.5217 5.13047 29.5217 4.31531 28.7278C3.50015 27.9356 3.50015 26.6599 3.50015 24.1084V13.2819C3.50015 10.7305 3.50015 9.45474 4.31531 8.6626C5.13047 7.87046 6.44286 7.86865 9.06763 7.86865H22.1638C28.5834 7.86865 31.7941 7.86865 34.2525 9.14257C36.0603 10.0809 37.5686 11.4883 38.6074 13.2061C40.0196 15.5392 40.1527 18.6573 40.4189 24.8952C40.4928 26.5769 40.5298 27.4178 40.1915 28.0529C39.9438 28.5221 39.5631 28.9082 39.0917 29.1681C38.4521 29.5217 37.5871 29.5217 35.857 29.5217H34.9235M16.4392 29.5217H27.5298H16.4392Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06763 29.5217C6.44286 29.5217 5.13047 29.5217 4.31531 28.7278C3.50015 27.9356 3.50015 26.6599 3.50015 24.1084V13.2819C3.50015 10.7305 3.50015 9.45474 4.31531 8.6626C5.13047 7.87046 6.44286 7.86865 9.06763 7.86865H22.1638C28.5834 7.86865 31.7941 7.86865 34.2525 9.14257C36.0603 10.0809 37.5686 11.4883 38.6074 13.2061C40.0196 15.5393 40.1527 18.6573 40.4189 24.8952C40.4928 26.5769 40.5298 27.4178 40.1915 28.0529C39.9438 28.5221 39.5631 28.9082 39.0917 29.1681C38.4521 29.5217 37.5871 29.5217 35.857 29.5217H34.9235M16.4392 29.5217H27.5298",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5243 33.1313C13.5047 33.1313 14.445 32.751 15.1383 32.0743C15.8316 31.3975 16.2211 30.4795 16.2211 29.5224C16.2211 28.5653 15.8316 27.6474 15.1383 26.9706C14.445 26.2938 13.5047 25.9136 12.5243 25.9136C11.5438 25.9136 10.6035 26.2938 9.91018 26.9706C9.21688 27.6474 8.82739 28.5653 8.82739 29.5224C8.82739 30.4795 9.21688 31.3975 9.91018 32.0743C10.6035 32.751 11.5438 33.1313 12.5243 33.1313ZM31.0086 33.1313C31.989 33.1313 32.9294 32.751 33.6227 32.0743C34.316 31.3975 34.7054 30.4795 34.7054 29.5224C34.7054 28.5653 34.316 27.6474 33.6227 26.9706C32.9294 26.2938 31.989 25.9136 31.0086 25.9136C30.0281 25.9136 29.0878 26.2938 28.3945 26.9706C27.7012 27.6474 27.3117 28.5653 27.3117 29.5224C27.3117 30.4795 27.7012 31.3975 28.3945 32.0743C29.0878 32.751 30.0281 33.1313 31.0086 33.1313Z",
    fill: "#F5F5F5",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4606 18.292L25.0997 18.3376M25.0997 18.3376L18.6846 12.699M25.0997 18.3376L15.0168 18.4746L13.184 16.8636M25.0997 18.3376L19.7514 24.1361",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAirportTransferIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/airport-transfer-icon.95efd4d7.svg";
export { ForwardRef as ReactComponent };